import { IconCalendarBolt, IconCalendarTime } from '@tabler/icons-react';

const trials = {
    id: 'trials',
    title: 'TRIALS',
    icon: IconCalendarTime,
    type: 'group',
    children: [
        {
            id: 'trials-list',
            title: 'TRIALS',
            type: 'item',
            url: '/trials',
            icon: IconCalendarTime,
            breadcrumbs: false,
            tags: [
                'trial',
                'trials',
                'client trial',
                'trial account',
                'trial deployment',
                'trial access',
                'trial site',
                'demo',
                'demo account',
                'demo site',
                'evaluation',
                'test environment',
                'sandbox',
                'temporary account',
                'temporary access',
                'trial period',
                'trial client',
                'free trial',
                'trial setup',
                'trial management',
                'trial organisation',
                'trial organization'
            ]
        },
        {
            id: 'trial-requests',
            title: 'TRIAL REQUESTS',
            type: 'item',
            url: '/trial-requests',
            icon: IconCalendarBolt,
            breadcrumbs: false,
            tags: [
                'trial request',
                'trial requests',
                'client trial request',
                'request trial',
                'trial signup',
                'trial registration',
                'demo request',
                'demo signup',
                'new trial request',
                'pending trial',
                'awaiting approval',
                'trial application',
                'request details',
                'submitted request',
                'trial onboarding',
                'trial account request',
                'trial setup request',
                'trial queue',
                'request review',
                'trial approval',
                'admin review'
            ]
        }
    ]
};

export default trials;
